import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MaterialSpecsOverview } from "pages/MaterialSpecs/components";
import {
    fetchBookings,
    getAdDetails,
    getAllMaterialSpecifications,
    getMaterialsProcessingStatus,
} from "store/features/materialSpecs/specs";
import { useProcessingStatus } from "hooks";
import { MaterialSpecsProvider } from "pages/MaterialSpecs/components/MaterialSpecsProvider/MaterialSpecsProvider";
import { isIFrame } from "utils";

export const MaterialSpecs = () => {
    const dispatch = useDispatch();
    const materialSpecifications = useSelector(getAllMaterialSpecifications);
    const adDetails = useSelector(getAdDetails);
    const { hasError, errorMessage } = useSelector(getMaterialsProcessingStatus);
    // TODO: ThirdParty needs to be taken of from material specs fetch request
    useProcessingStatus(false, hasError, errorMessage);

    useEffect(() => {
        dispatch(fetchBookings.request());
        // eslint-disable-next-line
    }, []);

    // this effect should be fired once when adDetails are populated
    useEffect(() => {
        if (adDetails) {
            if (isIFrame) {
                window.parent.document.title = adDetails.orderNo;
            }

            document.title = adDetails.orderNo;
        }
    }, [adDetails]);

    return (
        <MaterialSpecsProvider materialSpecifications={materialSpecifications}>
            <MaterialSpecsOverview />
        </MaterialSpecsProvider>
    );
};
